<template>
  <div class="flex flex-row" v-if="label || tooltip">
    <label class="mb-2 block" v-if="label">{{ label }}</label>
    <Tooltip placement="right" v-if="tooltip">
      <template #title>
        <p class="p-1 leading-snug">{{ tooltip }}</p>
      </template>
      <svg class="ml-2 mt-1" viewBox="0 0 18 18" height="14" width="14">
        <path
          d="M8.998 17.995A8.998 8.998 0 108.997 0a8.998 8.998 0 000 17.996zm.75-4.498h-1.5V7.498h1.5v5.999zm-.75-9.186a.938.938 0 110 1.876.938.938 0 010-1.876z"
          :fill="props.customColor"
          fill-rule="nonzero"
        />
      </svg>
    </Tooltip>
  </div>
  <select
    v-bind="$attrs"
    :value="modelValue"
    @change="selectChanged"
    class="bg-white border rounded text-gray-700 bg-lightGrey py-2 px-3 focus:outline-none w-full"
  >
    <slot />
  </select>
</template>

<script setup lang="ts">
import { Tooltip } from 'ant-design-vue';

const props = withDefaults(
  defineProps<{
    label?: string;
    tooltip?: string;
    customColor?: string;
    modelValue: string | number | boolean;
  }>(),
  {
    modelValue: '',
    customColor: '#99a0cb',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const selectChanged = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLSelectElement).value);
};
</script>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'BrandSelect',
  inheritAttrs: false,
});
</script>
<style src="ant-design-vue/lib/tooltip/style/index.css" />
